<div #basemapSwitcherArea></div>
